(() => {
  if (!window.klaviyo) {
    window._klOnsite = window._klOnsite || [];

    try {
      window.klaviyo = new Proxy(
        {},
        {
          get(_target, property) {
            if (property === 'push') {
              return (...args) => window._klOnsite.push(...args);
            }

            return (...args) => {
              const callback = typeof args[args.length - 1] === 'function' ? args.pop() : undefined;

              return new Promise((resolve) => {
                window._klOnsite.push([
                  property,
                  ...args,
                  (result) => {
                    if (callback) callback(result);
                    resolve(result);
                  },
                ]);
              });
            };
          },
        }
      );
    } catch (_error) {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push = (...args) => window._klOnsite.push(...args);
    }
  }

  const script = document.currentScript;
  if (!script) return;

  const { collectionName, collectionHandle, collectionId } = script.dataset;
  if (!collectionName || !collectionHandle || !collectionId) return;

  window.klaviyo.track(
    'Viewed Collection',
    {
      CollectionName: collectionName,
      CollectionHandle: collectionHandle,
      CollectionID: Number(collectionId),
      URL: window.location.href,
    }
  );
})();
